<template>
    <dashboard-layout>
        <div class="row">
            <div class="col-md-3 mb-2 pt-2"><h6 class="text-muted mb-1">Review questions </h6></div>
<!--            <div class="col mb-2">-->
<!--                <div class="input-group">-->
<!--                    <button class="btn btn-primary" type="submit" @click="getResults"><i class="ti ti-search"></i></button>-->
<!--                    <input type="text" class="form-control" v-model="q.q" placeholder="Search..." aria-label="Search">-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="mb-0 position-relative col-md-2 mb-2">-->
<!--                <select class="form-select form-control" v-model="q._order_by" @change="getResults">-->
<!--                    <option value="date">Sort by date</option>-->
<!--                    <option value="lasts">Sort lasts</option>-->
<!--                </select>-->
<!--            </div>-->
        </div>
        <div class="row g-2">
            <div class="col-xl-5 col-lg-5 col-md-5 col-12 mt-4">
                <div class="card border-0 shadow rounded p-4 mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                        <div class="d-flex align-items-center">
                            <div class="flex-1">
                                <h6 class="mb-0">Content</h6>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div v-for="subject in form_options?.subjects" :key="subject.id" class="rounded mb-1 card">
                            <div class="card-header p-1 bg-transparent border-bottom">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" :id="'subjects-' + subject.id"
                                           :value="subject.id" v-model="q.subjects" @change="getResults">
                                    <label class="form-check-label" :for="'subjects-' + subject.id">{{ subject.name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="btn-group btn-group-sm" role="group" aria-label="">
                            <input type="radio" class="btn-check" name="is_correct" id="All" autocomplete="off" value="" v-model="q.is_correct" @change="getResults">
                            <label class="btn btn-outline-primary " for="All">All questions</label>

                            <input type="radio" class="btn-check" name="is_correct" id="Incorrect" autocomplete="off" value="0" v-model="q.is_correct" @change="getResults">
                            <label class="btn btn-outline-primary " for="Incorrect">Incorrect</label>

                            <input type="radio" class="btn-check" name="is_correct" id="Correct" autocomplete="off" value="1" v-model="q.is_correct" @change="getResults">
                            <label class="btn btn-outline-primary " for="Correct">Correct</label>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="btn-group btn-group-sm" role="group" aria-label="">
                            <input type="radio" class="btn-check" name="only_flagged" id="AllQ" autocomplete="off" value="" v-model="q.only_flagged" @change="getResults">
                            <label class="btn btn-outline-primary " for="AllQ">All questions</label>

                            <input type="radio" class="btn-check" name="only_flagged" id="Flagged" autocomplete="off" value="1" v-model="q.only_flagged" @change="getResults">
                            <label class="btn btn-outline-primary " for="Flagged">Flagged Questions</label>

                        </div>
                    </div>
                    <div class="mb-4 row">
                        <div class="col-md-3 p-2">Sort by </div>
                        <div class="col-md-9">
                            <select class="form-select form-control" v-model="q._order_by" @change="getResults">
                                <option value="date">date</option>
                                <option value="lasts">lasts</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-7 col-lg-7 col-md-7 col-12 mt-4">
                <div class="table-responsive bg-white shadow rounded mb-2">
                    <table class="table mb-0">
                        <thead>
                        <tr>
                            <th class="border-bottom">Question</th>
                            <th class="border-bottom"></th>
                            <th class="p-3 text-end border-bottom text-muted fw-light" style="width: 93px">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items?.data" :key="item.id">
                            <td>
                                <a href="javascript:void(0)" class="text-dark"
                                   data-bs-toggle="modal" data-bs-target="#questionModal"
                                   @click="setQuestion(item)">
                                    <div class="d-flex justify-content-between">
                                        {{ item.question?.question }}
                                    </div>
<!--                                    <span class="text-muted">{{ item.question?.description }}</span>-->
                                </a>
                            </td>
                            <td>
                                <i v-if="item.is_correct" class="ti ti-check-box text-success"></i>
                                <i v-else class="ti ti-close text-danger"></i>
                            </td>
                            <td class="p-3 text-end text-muted fw-light">{{ item.created_at }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Bootstrap5Pagination
                    class="mb-0"
                    :data="items"
                    :limit="2"
                    :show-disabled="false"
                    :size="'default'"
                    :align="'center'"
                    @pagination-change-page="getResults"
                />

                <question-modal :question="currentQuestionItem" />

            </div>
        </div>
    </dashboard-layout>
</template>

<script>
import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";
import questionModal from "../question_discussion/question-modal.vue";

const toast = useToast();

export default {
    components: {
        questionModal,
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            currentQuestionItem: null,
            items: [],
            form_options: {
                subjects: [],

            },
            q: {
                subjects: [],
                is_correct: '',
                only_flagged: '',
                ...this.$route.query
            },
        }
    },
    created() {
        this.getResults(1);
        const id = toast.info('getting options ...', {icon: 'fa-light fa-filter-list'});
        axios.get('student_answers/create', {
            params: {
                'subscribe_id': this.$route?.params?.subscribe_id
            }
        }).then(response => {
            toast.dismiss(id);
            this.form_options = response.data.elements;
        }).catch(error => {
            toast.dismiss(id);
            if (error.response) {
                this.validationErrors = error.response.data.errors;
            }
        });
    },
    methods: {
        getResults(page = 1) {
            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});
            axios.get('student_answers', {
                params: {
                    'page': page,
                    ...this.q,
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                // this.$router.replace({
                //     name: "student_answers.index",
                //     query: {
                //         'page': page,
                //         ...this.q
                //     }
                // });
            }).catch(function (error) {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        },
        setQuestion(item){
            this.currentQuestionItem = item?.question;
        }
    }
}
</script>
